import axios, {AxiosStatic} from 'axios'
// axios.defaults.baseURL =  process.env.BASE_API as string
// axios.defaults.baseURL ="http://192.168.1.84:8082"
// axios.interceptors.request.use(config => {
//     if (localStorage.getItem('online-token')) {
//         config.headers['online-token'] = localStorage.getItem('online-token')
//     }
//     return config
// })
//
// axios.interceptors.response.use(response => response, error => {
//     alert(error+"错误")
//     if (error.response.status === 401) {
//         // 跳转到登录页面
//
//     }
// })


// export function getAuthorizedToken(conf:any) {
//     axios.get('/').then((data) => {
//         alert('获取权限token' + data)
//     },(data)=>{
//         alert("ddd")
//     })
//     // axios.post('/', conf).then((data) => {
//     //     alert('获取权限token' + data)
//     // })
// }
// export  default   axios  ;


// 创建axios实例
const service = axios.create({
    baseURL: "https://classapi.magaoedu.com",
    // baseURL: "http://192.168.1.84:8123",
    timeout: 1200000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (localStorage.getItem('online-token')) {
            config.headers['online-token'] = localStorage.getItem('online-token')
        }
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        // Do something with request error
        // console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const code = response.status
        if (code < 200 || code > 300) {
            // Notification.error({
            //     title: response.message
            // })
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        let code = 0
        try {
            code = error.response.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                // Notification.error({
                //     title: '网络请求超时',
                //     duration: 2500
                // })
                return Promise.reject(error)
            }
            if (error.toString().indexOf('Error: Network Error') !== -1) {
                // Notification.error({
                //     title: '网络请求错误',
                //     duration: 2500
                // })
                return Promise.reject(error)
            }
        }
        if (code === 401) {
        } else if (code === 403) {
            // router.push({ path: '/401' })
        } else {
            // const errorMsg = error.response.data.message
            // if (errorMsg !== undefined) {
            //     Notification.error({
            //         title: errorMsg,
            //         duration: 3000
            //     })
            // }
        }
        return Promise.reject(error)
    }
)
export default service
